import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ImageIcon } from "../../common/ImageIcon";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { CONTACT_FORM_URL } from "../../common/utils/constants";
import { scrollToSection } from "../../common/utils/scrollToSection";
import {
  ContactMeta,
  Copyright,
  Extra,
  FooterContainer,
  FooterLink,
  FooterSection,
  FormLink,
  LogoContainer,
  MetaLabel,
  MetaValue,
  NavLink,
  Para,
  ProductSwitch,
  ProductSwitchContainer,
  Title,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const SOLUTION_LINKS = [
  { label: "IT 资源平台", section: "solution" },
  { label: "信息安全", section: "solution" },
  { label: "IT 运维服务", section: "solution" },
  { label: "数字化办公", section: "solution" },
  { label: "企业 AI 智能体", path: "/solutions/ai-agent" },
  { label: "综合弱电", path: "/solutions/elv" },
];

const COMPANY_LINKS = [
  { label: "公司介绍", section: "about-us" },
  { label: "客户案例", section: "customer" },
  {
    label: "加入我们",
    href: "https://www.zhipin.com/gongsi/667242035d4cb1f11n1y0tW8FVE~.html?ka=search_rcmd_company_name_667242035d4cb1f11n1y0tW8FVE~_custompage",
  },
];

const CONTACT_META = [
  { label: "邮箱", value: "contact@ffaninfo.com" },
  { label: "地址", value: "上海市长宁区金钟路968号11号楼" },
];

const SocialLink = ({ href, src }: SocialLinkProps) => (
  <a
    style={{ marginLeft: "10px" }}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    key={src}
    aria-label={src}
  >
    <SvgIcon src={src} width="25px" height="25px" />
  </a>
);

const Footer = ({ t }: any) => {
  const history = useHistory();

  // 页脚在所有页面都会渲染，跳转首页锚点时需要先切回首页。
  const goToSection = (section: string) => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/home"
    ) {
      scrollToSection(section);
      return;
    }

    history.push({ pathname: "/", hash: section });
  };

  const renderLink = (link: {
    label: string;
    section?: string;
    path?: string;
    href?: string;
  }) => {
    if (link.href) {
      return (
        <FooterLink
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(link.label)}
        </FooterLink>
      );
    }

    return (
      <FooterLink
        key={link.label}
        href={link.path || `/#${link.section}`}
        onClick={(event) => {
          event.preventDefault();

          if (link.path) {
            history.push(link.path);
            return;
          }

          goToSection(link.section as string);
        }}
      >
        {t(link.label)}
      </FooterLink>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={8} md={8} sm={12} xs={24}>
              <Title>{t("联系我们")}</Title>
              <Para>{t("有任何问题欢迎随时联系，我们会尽快回复。")}</Para>
              <FormLink
                href={CONTACT_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("填写联系表单")}
              </FormLink>
              {CONTACT_META.map((meta) => (
                <ContactMeta key={meta.label}>
                  <MetaLabel>{t(meta.label)}</MetaLabel>
                  <MetaValue>{meta.value}</MetaValue>
                </ContactMeta>
              ))}
            </Col>
            <Col lg={5} md={5} sm={12} xs={24}>
              <Title>{t("解决方案")}</Title>
              {SOLUTION_LINKS.map(renderLink)}
            </Col>
            <Col lg={5} md={5} sm={12} xs={24}>
              <Title>{t("公司")}</Title>
              {COMPANY_LINKS.map(renderLink)}
            </Col>
            <Col lg={4} md={4} sm={12} xs={24}>
              <Title>{t("特推产品")}</Title>
              <ProductSwitchContainer>
                <ProductSwitch
                  onClick={() =>
                    window.open("https://www.donbe.cc", "_blank", "noopener")
                  }
                >
                  <ImageIcon
                    src="donbe.png"
                    aria-label="donbe"
                    width="30px"
                    height="30px"
                  />
                </ProductSwitch>
              </ProductSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <ImageIcon
                  src="logo-ffan.png"
                  aria-label="homepage"
                  width="90px"
                  height="40px"
                />
              </LogoContainer>
            </NavLink>
            <Copyright>
              Copyright &copy; 上海非帆数码科技有限公司 ffaninfo.com |{" "}
              <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">
                沪ICP备2023011729号-1
              </a>
            </Copyright>
            <div>
              <FooterContainer>
                <SocialLink
                  href="https://github.com/donbe-cc"
                  src="github.svg"
                />
                <SocialLink
                  href="https://www.zhihu.com/org/dong-bi-ke-ji"
                  src="zhihu.svg"
                />
              </FooterContainer>
            </div>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
